import { $api } from "../generated/client";

type UseGiftCodesStatsQueryOptions = {
	shopId: string;
	fromTimestamp?: number;
	toTimestamp?: number;
};

export default function useGiftCodesStats({
	shopId,
	fromTimestamp,
	toTimestamp,
}: UseGiftCodesStatsQueryOptions) {
	return $api.useQuery("get", "/shops/{shopId}/gift-codes/stats", {
		params: {
			path: { shopId },
			query: { fromTimestamp, toTimestamp },
		},
	});
}
